import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import dt from '../../../../shared/theme';
import { useGetFundCategories } from '../../../../services/lwadmin/data-provider/fund-category-service';
import useStore from './store-hook';

const Container = styled.div`
  width: 100%;
  display: flex;
  position: sticky;
  top: 130px;
  background-color: ${props => dt(props).theme.bodyBackgroundColor};
  z-index: 1;
  align-items: center;
  margin-bottom: 16px;
  padding: 24px 0 6px;
  border-bottom: 1px solid ${props => dt(props).theme.primaryColor};
  font: ${props => dt(props).theme.fontWeightHeavy} 16px/120% ${props => dt(props).theme.fontFamilyBody};

  & > .category {
    width: 45%;
  }

  & > .asset-class {
    width: 30%;
  }

  & > .action {
    padding-left: 20px;
    width: 25%;
  }
`;

const Action = styled.i`
  margin-right: 24px;

  &:hover {
    cursor: pointer;
  }
`;

export default function Header() {
  const categories = useStore(state => state.categories);
  const set = useStore(state => state.set);
  const [, getCategories] = useGetFundCategories();

  const refresh = e => {
    e && e.preventDefault();

    getCategories().then(resp => set(state => {
      state.categories = _.get(resp, 'data.categories', []);
    }));
  };

  const addNewCategory = e => {
    e && e.preventDefault();

    const newCategory = { id: null, name: '', fundAssetClassId: null };

    set(state => {
      state.categories = [newCategory, ...categories];
    });
  };

  return (
    <Container>
      <span className="category">Category</span>
      <span className="asset-class">Mapped Asset Class</span>
      <span className="action">
        <Action className="fa fa-refresh" onClick={refresh} />
        <Action className="fa fa-plus" onClick={addNewCategory} />
      </span>
    </Container>
  );
}
